import gql from 'graphql-tag';

/**
 * Mutation to submit a new advertising campaign.
 *
 * @param input - Campaign submission data including campaign name, type, dates, design files, and click-through URL (required)
 * @returns Order number for the submitted campaign
 * @usedIn Campaign layout (campaign submission flow)
 */
export const SUBMIT_CAMPAIGN = gql`
  mutation submitCampaign($input: SubmitCampaignInput!) {
    submitCampaign(input: $input) {
      orderNumber
    }
  }
`;
